import { defaultState } from './reducer.defaultState';
import { DealersInsightsLevelActionTypes } from './constants';

export const level = (state = defaultState(), action) => {
  switch (action.type) {
    case DealersInsightsLevelActionTypes.SET_LEVEL:
    case DealersInsightsLevelActionTypes.SET_INITIAL_LEVEL:
      return {
        ...state,
        currentLevel: action.currentLevel,
      };
    case DealersInsightsLevelActionTypes.SET_DEALER_ID:
    case DealersInsightsLevelActionTypes.MANUALLY_SET_DEALER_ID:
      return {
        ...state,
        currentDealerId: action.currentDealerId,
      };
    case DealersInsightsLevelActionTypes.RESET_STATE:
      return {
        ...defaultState(),
      };
    default:
      return state;
  }
};
